import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/layout/index.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/src/components/atoms/skeletons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/banner-search/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/header/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/pages/AntiScreenshot/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/pages/OnlineUsers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/services/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/assistant/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndexedDBProvider"] */ "/app/src/stores/context/IndexedDBProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/app/src/stores/context/socketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/stores/context/unauthorized.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/global.scss");
